import * as Yup from 'yup';

export const ReasonToDeleteAccountSchema = Yup.object().shape({
  reasonToDeleteAccount: Yup.string().required('Please provide your deletion reason')
});

export type ReasonToDeleteAccountDataType = Yup.InferType<typeof ReasonToDeleteAccountSchema>;

type InitialValues = {
  reasonToDeleteAccount: string;
};

export const ReasonToDeleteAccountInitialValues: InitialValues = {
  reasonToDeleteAccount: '',
};

export interface ReasonToDeleteAccountInterface {
  reasonToDeleteAccount: string;
}
